// src/config.js
const API_CONFIG = { BASE_URL: "https://api.flyhome.in/" };
//console.log("API_CONFIG", API_CONFIG);

export default API_CONFIG;
